import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import {
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalRoot,
} from '@mentimeter/ragnar-ui/modal';
import { Text } from '@mentimeter/ragnar-ui/text';
import { ThemeMentiLight } from '@mentimeter/ragnar-ui/themes';
import { usePresentationActions } from '../../misc/presentation-actions';
import { CURRENT_SESSION_INDEX } from '../../utils/constants';
import { useTranslate } from '../../state/translation';
import { useToolbarModals } from '../toolbar-modals';
import { useSessions } from '../../data-mediation';

export const DeleteSessionModal = () => {
  const { modalDeleteSessionId, setModalDeleteSessionId } = useToolbarModals();
  const { activeSession } = useSessions();
  const { deleteSession, setActiveSession } = usePresentationActions();
  const translate = useTranslate();

  const handleDeleteSession = React.useCallback(() => {
    if (modalDeleteSessionId === null) return;
    deleteSession(modalDeleteSessionId);
    if (modalDeleteSessionId === activeSession) {
      setActiveSession(CURRENT_SESSION_INDEX);
    }
    setModalDeleteSessionId(null);
  }, [
    activeSession,
    deleteSession,
    modalDeleteSessionId,
    setActiveSession,
    setModalDeleteSessionId,
  ]);

  return (
    <ModalRoot
      open={modalDeleteSessionId !== null}
      onOpenChange={() => setModalDeleteSessionId(null)}
    >
      <ModalContainer>
        <ThemeMentiLight>
          <Box bg="bg">
            <ModalHeader dismissLabel="Close delete session dialog">
              {translate('actions.delete_session')}
            </ModalHeader>
            <ModalBody>
              <Text mb="space6">
                {translate('toolbar.delete_session_confirmation', {
                  session_name: modalDeleteSessionId! + 1,
                })}
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button
                size="large"
                variant="secondary"
                onClick={() => setModalDeleteSessionId(null)}
              >
                {translate('actions.cancel')}
              </Button>
              <Button
                size="large"
                variant="primary"
                onClick={handleDeleteSession}
              >
                {translate('actions.delete_session')}
              </Button>
            </ModalFooter>
          </Box>
        </ThemeMentiLight>
      </ModalContainer>
    </ModalRoot>
  );
};
